import { render, staticRenderFns } from "./edit-email-template-modal.vue?vue&type=template&id=19a6d646"
import script from "./edit-email-template-modal.vue?vue&type=script&lang=ts"
export * from "./edit-email-template-modal.vue?vue&type=script&lang=ts"
import style0 from "./edit-email-template-modal.vue?vue&type=style&index=0&id=19a6d646&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a6d646')) {
      api.createRecord('19a6d646', component.options)
    } else {
      api.reload('19a6d646', component.options)
    }
    module.hot.accept("./edit-email-template-modal.vue?vue&type=template&id=19a6d646", function () {
      api.rerender('19a6d646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/email-settings-tab/edit-email-template-modal/edit-email-template-modal.vue"
export default component.exports